import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import RouteAccessHelper from "./route-access-helper";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
export default router;

router.beforeEach(async (to, from, next) => {
  if (RouteAccessHelper.isAuthenticated()) {
    /** showForAllLoggedUsers: true,
       * if all the logged users are allowed to go in regardless of the role */
    const showForAllLoggedUsers = ('showForAllLoggedUsers' in to.meta) ? to.meta.showForAllLoggedUsers : false;

    if (showForAllLoggedUsers) {
      next();
    } else if (RouteAccessHelper.isUserAuthorized(to.name)) {
      next();
    } else {
      console.log('User not authorized, Redirecting to Home');
      next('/');
    }
  } else {
    /** showForGuestUsers: true,
       * if guest users are allowed to go in, but not managed on the server */
    const showForGuestUsers = ('showForGuestUsers' in to.meta) ? to.meta.showForGuestUsers : false;
    if (showForGuestUsers) {
      next();
    } else if (RouteAccessHelper.isGuestAuthorized(to.name)) {
      next();
    } else {
      console.log('Guest not authorized, Redirecting to Login');
      next('/login');
    }
  }
});
